import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { useIsSpecificViewportWidth } from '../../../../hooks/useIsSpecificViewportWidth';
import { useAppSelector } from '../../../../redux/store';

const ContactImageMessage = ({
	message,
}: {
	message: { message: string };
	isUser?: boolean;
}) => {
	const { isLessThanDesktopBase } = useIsSpecificViewportWidth();
	const chat = useAppSelector(state => state.chat.chat);
	return (
		<>
			{/* <ModalComponent
				type="modal"
				header="Image"
				openState={true}
				onClose={() => null}
			>
				<Image
					style={[
						styles.largeImage,
						isLessThanDesktopBase && styles.mobileSizeImage,
					]}
					source={{
						uri: message.message,
					}}
				/>
			</ModalComponent> */}
			<View style={styles.flex1}>
				<Image
					style={styles.profileImage}
					source={{
						uri: chat?.contactPerson?.personalInformation
							?.profileImageLink,
					}}
				/>
				<Image
					style={[
						styles.image,
						isLessThanDesktopBase && styles.mobileSizeImage,
					]}
					source={{
						uri: message.message,
					}}
				/>
			</View>
		</>
	);
};

const styles = StyleSheet.create({
	flex1: {
		flexDirection: 'row',
		marginTop: 15,
		height: 150,
		justifyContent: 'flex-start',
	},
	profileImage: {
		width: 30,
		height: 30,
		marginRight: 20,
		borderRadius: 25,
	},
	image: {
		width: '30%',
		height: '100%',
		borderRadius: 6,
		marginBottom: 10,
		cursor: 'pointer',
	},
	largeImage: {
		height: 400,
		width: '100%',
	},
	detailImage: {
		width: 224,
		height: 204,
	},
	mobileSizeImage: {
		width: 159,
		height: 126,
	},
	mobileSizeDetailImage: {
		width: 324,
		height: 304,
	},
});

export default ContactImageMessage;
